import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { SearchSupplierService } from '../../service/supplier/search/search-supplier.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ServerService } from '../../service/server/server.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SaleAttachmentComponent } from '../sale-attachment/sale-attachment.component';
import { SaleDocumentDeclarationComponent } from '../sale-document/sale-document-declaration/sale-document-declaration.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SalePrintComponent } from '../sale-print/sale-print.component';
import { UserInsertComponent } from '../../system/user/user-insert/user-insert.component';

@Component({
  selector: 'app-sale-factor-detaile',
  templateUrl: './sale-factor-detaile.component.html',
  styleUrls: ['./sale-factor-detaile.component.scss']
})
export class SaleFactorDetaileComponent implements OnInit {
  public isOnline: boolean;
  public username: string; public fname: string; public lname: string;
  public server: string = this.serverService.get_server();
  public lang: any = JSON.parse(<any>localStorage.getItem('lang'));
  public loading = false;
  public subscription: Subscription;
  public err: string; public err_validation: boolean = false;
  public err_internet_text: string; public err_internet_validation: boolean;
  public task_type: number;
  public confirm_delete: boolean;
  public count_total: any = "--"; public page_number_first: any = "--"; public page_number_second: any = "--"; public page: number = 1;
  public type: number; public type_search: number;
  public type_send: number;
  public waiting_excell: number = 1;
  public show_excell: number = 1;
  public export_code: number;
  year: number;
  plan: number;
  result: any;
  service_id: any;
  shop: any;
  public document: number;
  list_forms: any = [];
  @ViewChild('modal_mwf2') modal_mwf2: any;
  @ViewChild('modal_mwf') modal_mwf: any;
  @ViewChild('fs') fs: any;
  @ViewChild('price_lsf_modal') price_lsf_modal: any;
  @ViewChild('mv_modal') mv_modal: any;
  @ViewChild('weight_modal') weight_modal: any;
  @ViewChild('factor') factor: any;
  @ViewChild('design_modal') design_modal: any;
  @ViewChild('install1_modal') install1_modal: any;
  @ViewChild('install2_modal') install2_modal: any;
  @ViewChild('price_all_without_discount_modal') price_all_without_discount_modal: any;
  @ViewChild('price_all1_modal') price_all1_modal: any;
  @ViewChild('price_all_modal') price_all_modal: any;
  @ViewChild('profile_user_modal') profile_user_modal: any;
  @ViewChild('myModalSelect') myModalSelect: any;
  @ViewChild('modal_contract') modal_contract: any;
  @ViewChild('modal_factor2') modal_factor2: any;
  @ViewChild('modal_factor3') modal_factor3: any;
  @ViewChild('modal_discount') modal_discount: any;
  @ViewChild('price_all_m_modal') price_all_m_modal: any;
  @ViewChild('modal_wast') modal_wast: any;
  shop_sazeh_price: number;
  shop_sazeh_price_price_lsf1: number;
  shop_sazeh_price_price_lsf2: number;
  shop_sazeh_price_price_lsf3: number;

  public a = 'PM';

  public obj = {};
  public data = {};
  public list_record: any = [];
  public list_floor: any = [];
  public list_crater_a: any = [];
  public list_crater_a_temp: any = [];
  public list_tip: any = [];
  public list_position: any = [];
  public list_site: any = [];
  public list_open_crater: any = [];
  public list_height: any = [];
  public list_place: any = [];
  public list_requester: any = [];
  public list_status: any = [];
  list_price: any = [];
  //******************************************************************************currency
  public id: number;
  public weight1: number;
  public weight2: number;
  public price1: number;
  public price2: number;
  public design: number;
  public design_temp: number;
  public design_all: number;
  public floor: string; public floor_title: any;
  public default_floor: any;
  public place: number;
  public default_place: any;
  public save_place: any;
  public access_update: boolean | undefined;
  public crater_a: number; public crater_a_title: any;
  public select_weight: number; public select_weight_title: any; public select_weight_weight: number;
  public select_weight_status: boolean = false;
  public type_ceil: number;
  public meter: number;
  public tip: number; public tip_title: any;
  public position: number; public position_title: any;
  public default_position: any;
  public site: number; public site_title: any;
  public default_site: any;
  public crater: number;
  public open_crater: number; public open_crater_title: any;
  public default_open_crater: any;
  public height: number; public height_title: any;
  public height_floor: any;
  public default_height: any;
  public bana_all_diff: number;
  public weight_diff: number;
  public design_diff: number;
  public price_lsf1_number_diff: number;
  public price_lsf2_number_diff: number;
  public price_lsf3_number_diff: number;
  public bullet: number;
  public code_factor: number;
  public contract: any;
  public install_diff: any;
  public install1_diff: any;
  public install2_diff: any;
  public discount: number;
  public discount_festival: number = 0;
  public discount_festival_price: number = 0;
  public discount_install2: number;
  public discount_all: number;
  public discount_mwf: number;
  public discount_price_lsf1: number;
  public discount_price_lsf2: number;
  public discount_price_lsf3: number;
  user_sms: number;

  public discount_design_all: number;
  public hard: number;
  public arch1: number;
  public arch2: number;
  public wast: number; public wast_price: number; public wast_weight: number;
  public address: string;
  public comment: string;
  public price: number;
  public weight: any;
  public weight1_diff: any;
  public default_select_weight: any;
  public mv: number;
  public bana_all: number;
  public i: number;
  public mwf2: number;
  public mwf: number;
  public price_lsf: number;
  public install: number;
  public install1: number;
  public install2: number;
  public f1: any; public f1_diff: any;
  public f2: any; public f2_diff: any;
  public f3: any; public f3_diff: any;
  public f4: any; public f4_diff: any;
  public f5: any; public f5_diff: any;
  public f6: any; public f6_diff: any;
  public f7: any; public f7_diff: any;
  public f8: any; public f8_diff: any;
  public price_lsf1_number: number;
  public price_lsf2_number: number;
  public price_lsf3_number: number;
  public price_lsf1_price: number;
  public price_lsf2_price: number;
  public price_lsf3_price: number;
  public price_lsf1: number;
  public price_lsf2: number;
  public price_lsf3: number;
  public number1: number;
  public price_all_without_discount: any; public price_all_factor2_without_discount: any; public price_all_factor3_without_discount: any;
  public price_all1: number;
  public price_all: number; price_all2: number;
  public tax_check_value: number;
  public percent: number;
  public price_final: number;
  public price_factor2: number; public price_factor2_tax: number; public price_factor2_final: number; public price_factor2_discount: number; public price_factor2_with_discount: number;
  public price_factor3: number; public price_factor3_tax: number; public price_factor3_final: number; public price_factor3_discount: number; public price_factor3_with_discount: number;
  public price_final_all: number;
  public bed_all: number;
  public remain: number;
  public remain_temp: number;
  public user_fname: string;
  public user_cellphone: number;
  public user_username: string;
  public install_place_title: any;

  public price_search: any;
  public place_search: any;
  public height_search: any;
  public open_crater_search: any;
  public site_search: any;
  public position_search: any;
  public design_search: any;
  public tip_search: any;
  public bana_all_search: any;
  public select_weight_search: any;
  public crater_a_search: any;
  public floor_search: any;
  public status_search: any;
  public tax_check_value_search: any;
  public bullet_search: any;
  public factor_type_search: any;
  public num: number;
  public factor_type: number;










  public requester_title: any;
  public requester_title_search: any;
  public requester_title2_search: any;
  public requester_title_search_modal: any;
  public requester_title2_search_modal: any;
  public username_search_modal: any;
  public obj_search_requester: any;
  public requester_contract_id: any;
  public factor_search: any;

  public requester_id: string;
  public requester_id_search: string;
  public factor_code: number;
  public best: number = 0;
  public bed: number = 0;
  public sum: number = 0;

  public type_user: number;
  public code: number;
  public limit_product: number;
  public product: number = 1;

  public pre_status: boolean; public next_status: boolean;
  public status_id: number; public status_id_temp: number;
  public search_state: boolean; public search_state_id: boolean;

  public num1: number = 0;
  public num2: number = 0;
  public num3: number = 0;
  public num4: number;
  public num5: number;
  public num6: number;
  public num7: number;
  public num8: number;
  public status: number;
  public disable_status1: boolean;
  public favorite_color: boolean;
  public task: number;
  public date: any;
  user_info: any = JSON.parse(<any>localStorage.getItem('user_info'));


  public file_id: number;
  public file_title_rename: string; public file_title_rename_validation: boolean;
  public file_title2_rename: string; public file_title2_rename_validation: boolean;
  public title_rename: string;
  public config: any;

  public list_process: any = [];
  user_id: number;

  constructor(public router: Router, public activatedRoute: ActivatedRoute, public serverService: ServerService
    , public dialog: MatDialog, private matSnackBar: MatSnackBar, public searchSupplierService: SearchSupplierService
    , public matDialogRef: MatDialogRef<SaleFactorDetaileComponent>
    , @Inject(MAT_DIALOG_DATA) private dialog_data: any) {
    if (dialog_data) {
      this.id = dialog_data.id;
      this.product = dialog_data.product;
      this.code = dialog_data.code;
      this.i = dialog_data.i;
      this.service_id = dialog_data.service_id;
    }
  }//end constructor




  ngOnInit() {
    this.user_id = this.user_info.user_id;
    this.isOnline = navigator.onLine;
    this.username = JSON.parse(<any>localStorage.getItem('username'));
    this.fname = JSON.parse(<any>localStorage.getItem('fname'));
    this.change_tip();
    this.recieve_crater_a();
    this.recieve_tip();
    this.recieve_position();
    this.recieve_site();
    this.recieve_place();
    this.recieve_status();
    this.check_access(4, 1);
  }//ngOnInit

  check_access(type_task: any, excel: number): any {
    if (this.serverService.check_internet1() == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 6, user_id: this.user_id, id: this.service_id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            //this.serverService.signout();
            var pe_message = "شما دسترسی به این سرویس را ندارید";
            var pe_action = "بستن";
            this.recieve_message(true, 'Access restrictions', pe_message, 1, 'close', pe_action);
          }
          else {
            this.loading = false;
            //if (type_task == 1) { this.insert(); }
            //if (type_task == 2) { this.update(); }
            //if (type_task == 3) { this.search(excel); }
            if (type_task == 4) { this.load_data(1, 1, 1); }
          }
        }//end if
        else {
          var pe_message = "خطا در دسترسی";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  load_data(page, task, excel) {
    if (this.check_internet() == false) { return; }
    this.loading = true;
    this.obj = { "lang": this.lang, 'address': 1526, id: this.id, user_id: this.user_id };
    this.subscription = this.serverService.post_address(this.server, 'new_address', this.obj).subscribe(
      (res) => {
        this.data = res;
        if (this.data['status'] == 1) {
          var x = res['result'][0];
          this.user_sms = res['result'][0].user_id;
          this.shop = res['shop'];
          x.pre_factor_lsf_order_price = Number(x['pre_factor_lsf_order_price']);
          x.bana_all = Number(x['pre_factor_lsf_order_meter']) + Number(x['pre_factor_lsf_order_bana_all_diff']);
          x.select_weight_weight = x.pre_factor_lsf_order_weight;// وزن اولیه با ارتفاع 3 متر
          x.pre_factor_lsf_order_weight = (Number(x.select_weight_weight) + ((Number(x.pre_factor_lsf_order_height_floor) - 3) * 5) + Number(x.pre_factor_lsf_order_weight1_diff)).toFixed(3);
          x.mv = Math.round(Number(x['bana_all']) * Number(x['pre_factor_lsf_order_weight']) + Number(x['pre_factor_lsf_order_weight_diff']));
          //x.mvf = Number(x['mv']) * Number(x['pre_factor_lsf_order_price']);
          if (x['pre_factor_lsf_order_bullet'] == 1) {
            x.price_lsf1_number = Math.round(Number(x['mv']) * 2 + Number(x['price_lsf1_number_diff']));
            x.price_lsf2_number = Math.round((Number(x['mv']) * 2) / 3 + Number(x['price_lsf2_number_diff']));
            x.price_lsf3_number = Math.round((Number(x['bana_all']) / Number(x['pre_factor_lsf_order_number']) * 65) / 100 + Number(x['price_lsf3_number_diff']));

            x.price_lsf1_price = Math.round(Number(x['price_lsf1_number']) * Number(x['pre_factor_lsf_order_price_lsf1']));
            x.price_lsf2_price = Math.round(Number(x['price_lsf2_number']) * Number(x['pre_factor_lsf_order_price_lsf2']));
            x.price_lsf3_price = Math.round(Number(x['price_lsf3_number']) * Number(x['pre_factor_lsf_order_price_lsf3']));
            x.price_lsf = Number(x['price_lsf1_price']) + Number(x['price_lsf2_price']) + Number(x['price_lsf3_price']);
          }
          else if (x['pre_factor_lsf_order_bullet'] == 2) {
            x.price_lsf1_number = 0;
            x.price_lsf2_number = 0;
            x.price_lsf3_number = 0;

            x.price_lsf1_price = 0;
            x.price_lsf2_price = 0;
            x.price_lsf3_price = 0;
            x.price_lsf = 0;
          }

          if (this.product == 1 || this.product == 4) {
            x.install = (parseFloat(x['pre_factor_lsf_order_f1']) + Number(x['pre_factor_lsf_order_f1_diff'])) * (parseFloat(x['pre_factor_lsf_order_f2']) + Number(x['pre_factor_lsf_order_f2_diff'])) * (parseFloat(x['pre_factor_lsf_order_f3']) + Number(x['pre_factor_lsf_order_f3_diff'])) * (parseFloat(x['pre_factor_lsf_order_f4']) + Number(x['pre_factor_lsf_order_f4_diff'])) * (parseFloat(x['pre_factor_lsf_order_f5']) + Number(x['pre_factor_lsf_order_f5_diff'])) * (parseFloat(x['pre_factor_lsf_order_f6']) + Number(x['pre_factor_lsf_order_f6_diff'])) * (parseFloat(x['pre_factor_lsf_order_f7']) + Number(x['pre_factor_lsf_order_f7_diff'])) * (parseFloat(x['pre_factor_lsf_order_f8']) * parseFloat(x['pre_factor_lsf_order_install_place_f8']) + Number(x['pre_factor_lsf_order_f8_diff'])) + Number(x['pre_factor_lsf_order_install_diff']);
            x.install1 = Math.round(Number(x['pre_factor_lsf_order_weight']) * Number(x['install']) + Number(x['pre_factor_lsf_order_install1_diff']));
            x.install2 = Math.round(Number(x['install']) * Number(x['mv'])) + Number(x['pre_factor_lsf_order_install2_diff']);
          }//end if
          else {
            x.install = 0;
            x.install1 = 0;
            x.install2 = 0;
          }//end else
          x.design = Number(x['pre_factor_lsf_order_design']);
          x.design_all = Number(x['design']) * Number(x['bana_all']) + Number(x['pre_factor_lsf_order_design_diff']);
          x.mwf = Number(x['mv']) * Number(x['pre_factor_lsf_order_price']);
          x.discount_festival_price = x.mwf * x['pre_factor_lsf_order_discount_festival'] / 100;

          x.mwf2 = Math.round(Number(x.mwf) / Number(x['bana_all']));
          x.arch1 = x['pre_factor_lsf_order_arch1'];
          x.arch2 = x['pre_factor_lsf_order_arch2'];
          x.wast = x['pre_factor_lsf_order_wast'];
          x.wast_weight = x['pre_factor_lsf_order_wast_weight'];
          x.wast_price = x['pre_factor_lsf_order_wast_price'];
          x.discount = x['pre_factor_lsf_order_discount'];
          x.pre_factor_lsf_order_hard = x['pre_factor_lsf_order_hard'];

          this.status_id_temp = x['pre_factor_lsf_order_status'];

          if (this.product == 3) {
            x['mwf'] = 0;
            x['price_lsf'] = 0;
            x['install2'] = 0;
            x['pre_factor_lsf_order_hard'] = 0;
            x['pre_factor_lsf_order_wast'] = 0;
          }
          x.price_all_without_discount = Number(x['mwf']) + Number(x['price_lsf']) + Number(x['install2']) +
            Number(x['design_all']) + Number(x['arch1']) + Number(x['arch2']) + Number(x['pre_factor_lsf_order_hard']);

          x.pre_factor_lsf_order_discount_festival = Number(x['pre_factor_lsf_order_discount_festival']);

          x.price_all_factor2_without_discount = Number(x['price_lsf']) + Number(x['mwf']);

          x.price_all_factor3_without_discount = Number(x['install2']) +
            Number(x['design_all']) + Number(x['arch1']) + Number(x['arch2']) + Number(x['pre_factor_lsf_order_hard']);

          x.discount = Number(x['pre_factor_lsf_order_discount']);
          //////////////////////////
          x.price_all = Math.round(Number(x['mwf']) + Number(x['price_lsf']) + Number(x['install2']) + Number(x['design_all']) + Number(x['arch1']) + Number(x['arch2']) + Number(x['pre_factor_lsf_order_wast']) - Number(x['discount']) - Number(x['discount_festival_price']));
          x.price_all1 = Math.round(Number(x['price_all'] / Number(x['bana_all'])));
          x.price_all2 = Math.round(Number(x['mwf']) + Number(x['price_lsf']));
          //////////////////////////
          if (x['pre_factor_lsf_order_tax_check_value'] == 2) { x['percent'] = Math.round(x['price_all'] * 9 / 100); }
          if (x['pre_factor_lsf_order_tax_check_value'] == 1) { x['percent'] = 0; }
          x.price_final = Math.round(Number(x['percent']) + Number(x['price_all']));
          ////////////////////////// 
          x.price_factor2_discount = Number(x['pre_factor_lsf_order_discount_price_lsf1']) + Number(x['pre_factor_lsf_order_discount_price_lsf2']) + Number(x['pre_factor_lsf_order_discount_price_lsf3']) + Number(x['pre_factor_lsf_order_discount_mwf']);
          x.price_factor2 = Math.round(Number(x['price_lsf']) + Number(x['mwf']));
          x.price_factor2_with_discount = Number(x.price_factor2) - Number(x.price_factor2_discount);
          if (x['pre_factor_lsf_order_tax_check_value'] == 2) { x.price_factor2_tax = Math.round(x['price_factor2_with_discount'] * 9 / 100); }
          if (x['pre_factor_lsf_order_tax_check_value'] == 1) { x.price_factor2_tax = 0; }
          x.price_factor2_final = Math.round(Number(x['price_factor2_with_discount']) + Number(x['price_factor2_tax']));
          //////////////////////////
          x.price_factor3_discount = Number(x['pre_factor_lsf_order_discount_design_all']) + Number(x['pre_factor_lsf_order_discount_install2']);
          x.price_factor3 = Math.round(Number(x['install2']) + Number(x['design_all']) + Number(x['arch1']) + Number(x['arch2']));
          x.price_factor3_with_discount = Number(x.price_factor3) - Number(x.price_factor3_discount);
          if (x['pre_factor_lsf_order_tax_check_value'] == 2) { x.price_factor3_tax = Math.round(x['price_factor3_with_discount'] * 9 / 100); }
          if (x['pre_factor_lsf_order_tax_check_value'] == 1) { x.price_factor3_tax = 0; }
          x.price_factor3_final = Math.round(Number(x['price_factor3_with_discount']) + Number(x['price_factor3_tax']));
          //////////////////////////
          x.pre_factor_lsf_order_favorite = Number(x['pre_factor_lsf_order_favorite']);
          this.price_final_all = x.price_final + this.price_final_all;
          this.remain = this.remain + (x.bed - x.best);

          this.floor = x.pre_factor_lsf_order_floor;
          this.recieve_open_crater();
          this.recieve_height();
          this.serverService.send_services_id(this.code);


          this.change_task(2, 0
            , x.pre_factor_lsf_order_id, x.pre_factor_lsf_order_floor, x.pre_factor_lsf_order_number, x.pre_factor_lsf_order_crater_a, x.pre_factor_lsf_order_type_ceil, x.pre_factor_lsf_order_meter, x.pre_factor_lsf_order_tip
            , x.pre_factor_lsf_order_design, x.pre_factor_lsf_order_position, x.pre_factor_lsf_order_site, x.pre_factor_lsf_order_crater, x.pre_factor_lsf_order_height, x.pre_factor_lsf_order_install_place
            , x.bana_all, x.pre_factor_lsf_order_bana_all_diff, x.pre_factor_lsf_order_weight_diff, x.pre_factor_lsf_order_weight1_diff, x.pre_factor_lsf_order_design_diff, x.pre_factor_lsf_order_price_lsf1, x.pre_factor_lsf_order_price_lsf2, x.pre_factor_lsf_order_price_lsf3, x.price_lsf1_number, x.price_lsf2_number, x.price_lsf3_number, x.price_lsf1_price, x.price_lsf2_price, x.price_lsf3_price, x.price_lsf1_number_diff, x.price_lsf2_number_diff, x.price_lsf3_number_diff, x.pre_factor_lsf_order_install_diff, x.pre_factor_lsf_order_install1_diff, x.pre_factor_lsf_order_install2_diff, x.pre_factor_lsf_order_discount, x.pre_factor_lsf_order_discount_install2, x.pre_factor_lsf_order_discount_all, x.pre_factor_lsf_order_discount_mwf, x.pre_factor_lsf_order_discount_price_lsf1, x.pre_factor_lsf_order_discount_price_lsf2, x.pre_factor_lsf_order_discount_price_lsf3, x.pre_factor_lsf_order_discount_design_all, x.pre_factor_lsf_order_hard
            , x.pre_factor_lsf_order_arch1, x.pre_factor_lsf_order_arch2, x.pre_factor_lsf_order_address, x.pre_factor_lsf_order_comment
            , x.pre_factor_lsf_order_price, x.pre_factor_lsf_order_discount_festival, x.discount_festival_price, x.select_weight_weight, x.pre_factor_lsf_order_height_floor, x.mv, x.design_all, x.mwf2, x.mwf, x.price_lsf, x.install, x.install1, x.install2, x.pre_factor_lsf_order_f1, x.pre_factor_lsf_order_f2, x.pre_factor_lsf_order_f3, x.pre_factor_lsf_order_f4, x.pre_factor_lsf_order_f5, x.pre_factor_lsf_order_f6, x.pre_factor_lsf_order_f7, x.pre_factor_lsf_order_f8, x.pre_factor_lsf_order_install_place_f8, x.pre_factor_lsf_order_f1_diff, x.pre_factor_lsf_order_f2_diff, x.pre_factor_lsf_order_f3_diff, x.pre_factor_lsf_order_f4_diff, x.pre_factor_lsf_order_f5_diff, x.pre_factor_lsf_order_f6_diff, x.pre_factor_lsf_order_f7_diff, x.pre_factor_lsf_order_f8_diff
            , x.price_all_without_discount, x.price_all_factor2_without_discount, x.price_all_factor3_without_discount, x.price_all, x.price_all2, x.price_all1, x.percent, x.pre_factor_lsf_order_tax_check_value, x.price_final, x.price_factor2, x.price_factor2_tax, x.price_factor2_final, x.price_factor2_discount, x.price_factor2_with_discount, x.price_factor3, x.price_factor3_tax, x.price_factor3_final, x.price_factor3_discount, x.price_factor3_with_discount, x.user_title, x.user_userName, x.user_id, x.user_cellPhone, x.pre_factor_lsf_order_bullet
            , x.pre_factor_lsf_order_status, x.pre_factor_lsf_order_code_factor, x.pre_factor_lsf_order_contract, x.pre_factor_lsf_order_date, x.pre_factor_lsf_order_wast, x.pre_factor_lsf_order_wast_weight, x.pre_factor_lsf_order_wast_price);
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }//end else 
      }//end res:Response
    ) //ens dubscribe 
  }//end load data  

  //***********************************************************************************************************************************  
  update(type) {
    if (this.check_internet() == false) { return; }
    this.obj = {
      address: 1527,
      'username': this.username, 'id': this.id, 'type': type, 'code': this.code, 'floor': this.floor, 'f1': this.f1, 'number': this.number1, 'crater_a': this.crater_a
      , 'weight': this.select_weight_weight, 'weight2': parseInt(this.weight), 'weight1_diff': this.weight1_diff, mv: this.mv, 'weight_diff': this.weight_diff
      , 'f2': this.f2, 'type_ceil': this.type_ceil
      , 'bana_all': this.bana_all, 'tip': this.tip
      , 'design': this.design, design_all: this.design_all, 'design_diff': this.design_diff
      , mwf2: this.mwf2, mwf: this.mwf
      , 'position': this.position, 'f4': this.f4, 'site': this.site, 'f5': this.f5
      , 'open_crater': this.open_crater, 'f6': this.f6, 'height': this.height, 'f7': this.f7, 'place': this.place, 'f8': this.f8
      , 'discount': this.discount, 'hard': this.hard, 'arch1': this.arch1, 'arch2': this.arch2, 'requester': this.requester_id, 'address1': this.address, 'comment': this.comment
      , 'tax_check_value': this.tax_check_value, 'bullet': this.bullet, 'price': this.price
      , 'price_lsf': this.price_lsf, price_all1: this.price_all1
      , 'price_lsf1_number_diff': this.price_lsf1_number_diff, 'price_lsf2_number_diff': this.price_lsf2_number_diff
      , 'price_lsf3_number_diff': this.price_lsf3_number_diff
      , 'install_diff': this.install_diff, 'install1_diff': this.install1_diff, 'install2_diff': this.install2_diff
      , 'install': this.install.toFixed(2), 'install1': this.install1, 'install2': this.install2
      , 'f8_diff': this.f8_diff, 'code_factor': this.code_factor
      , 'price_lsf1': this.price_lsf1, 'price_lsf2': this.price_lsf2, 'price_lsf3': this.price_lsf3, 'status1': Number(this.status) + 1, 'contract': this.contract
      , 'discount_install2': this.discount_install2, 'discount_all': this.discount_all, 'discount_mwf': this.discount_mwf, 'discount_price_lsf1': this.discount_price_lsf1, 'discount_price_lsf2': this.discount_price_lsf2, 'discount_price_lsf3': this.discount_price_lsf3, 'discount_design_all': this.discount_design_all
      , 'type_product': this.product, 'wast': this.wast, 'wast_weight': this.wast_weight, 'wast_price': this.wast_price, 'discount_festival': this.discount_festival, 'height_floor': this.height_floor
      , 'price_all': this.price_all, 'price_all_m2': this.ConvertToRound(this.price_all / this.bana_all)
      , 'price_all_without_discount': this.price_all_without_discount, price_final: this.price_final, percent: this.percent
      , 'price_all_without_discount_m2': this.ConvertToRound(this.price_all_without_discount / this.bana_all)
      , 'status_id': this.status_id
      , 'price_lsf1_number': this.price_lsf1_number, 'price_lsf2_number': this.price_lsf2_number, price_lsf3_number: this.price_lsf3_number
      , 'price_lsf1_price': this.price_lsf1_price, 'price_lsf2_price': this.price_lsf2_price, price_lsf3_price: this.price_lsf3_price
    };
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', this.obj).subscribe(
      (res) => {
        if (res['status'] == 1) {
          if (this.status_id_temp != this.status_id) {
            //type = 3;
          }
          this.result = {
            'bana_all': this.bana_all, i: this.i, 'pre_factor_lsf_order_price': res['result'][0].pre_factor_lsf_order_price
            , 'price_all_without_discount': this.price_all_without_discount
            , 'pre_factor_lsf_order_meter': this.bana_all
            , 'price_all': this.price_all
            , 'price_all_m2': this.ConvertToRound(this.price_all / this.bana_all)
            , 'percent': this.percent
            , 'price_final': this.price_final
            , 'discount': this.discount
            , 'bed': res['result'][0].bed
            , 'best': res['result'][0].best
            , 'user_title': res['result'][0].user_title
            , 'requester_id': this.user_sms
            , 'type': type
          };
          this.check_ckd();
          if (type == 2 || type == 3) {
            this.close();
          }
          this.loading = false;
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve	', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end 

  check_ckd() {
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10605, id: this.id }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          if (res['result'][0].count == 0) {
            this.insert_mwf();
          } else {
            this.update_ckd();
          }
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert_mwf() {
    var obj = {
      address: 10574, seleton_id: this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.insert_design_all();//res['result'][0].pre_factor_lsf_order_design_all  طراحی سازه
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert_design_all() {
    var obj = {
      address: 10575, seleton_id: this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.insert_design_price_lsf(); //res['result'][0].pre_factor_lsf_order_price_lsf هزینه پیچ به تومان
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert_design_price_lsf() {
    var obj = {
      address: 10576, seleton_id: this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.insert_design_arch();
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  insert_design_arch() {
    var obj = {
      address: 10577, seleton_id: this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.insert_install2();
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  insert_install2() {
    var obj = {
      address: 10645, seleton_id: this.id
    }
    this.subscription = this.serverService.post_address(this.server, 'new_address', obj).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  update_ckd() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10582, id: this.id }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }


  print() {
    this.dialog.open(SalePrintComponent, {
      width: '100rem',
      height: '100vh',
      data: { id: this.id }
    });
  }

  //*******************************************************************************
  change_task(type, index, id, floor, number1, crater_a, type_ceil, meter, tip, design, position, site, open_crater, height, place, bana_all, bana_all_diff, weight_diff, weight1_diff, design_diff, price_lsf1, price_lsf2, price_lsf3, price_lsf1_number, price_lsf2_number, price_lsf3_number, price_lsf1_price, price_lsf2_price, price_lsf3_price, price_lsf1_number_diff, price_lsf2_number_diff, price_lsf3_number_diff, install_diff, install1_diff, install2_diff, discount, discount_install2, discount_all, discount_mwf, discount_price_lsf1, discount_price_lsf2, discount_price_lsf3, discount_design_all, hard, arch1, arch2, address, comment
    , price, discount_festival, discount_festival_price, weight, height_floor, mv, design_all, mwf2, mwf, price_lsf, install, install1, install2, f1, f2, f3, f4, f5, f6, f7, f8, place_f8, f1_diff, f2_diff, f3_diff, f4_diff, f5_diff, f6_diff, f7_diff, f8_diff, price_all_without_discount, price_all_factor2_without_discount, price_all_factor3_without_discount
    , price_all, price_all2, price_all1, percent, tax_check_value, price_final, price_factor2, price_factor2_tax, price_factor2_final, price_factor2_discount, price_factor2_with_discount, price_factor3, price_factor3_tax, price_factor3_final, price_factor3_discount, price_factor3_with_discount, fname, username, user_id, cellphone, bullet, status, code_factor, contract, date, wast, wast_weight, wast_price) {

    /*
    if( status != this.code ){this.disable_status1=true;}
    else{
     this.disable_status1=false;   
    }
    */
    this.i = index;
    this.id = id;
    this.floor = floor;
    if (type != 3) { this.default_floor = floor; }
    if (type == 3) { this.default_floor = this.floor_search; }
    this.f1_diff = f1_diff;
    this.f1 = Number(f1) + Number(f1_diff);
    this.number1 = number1;
    if (type != 3) {
      this.requester_title = fname;
      this.requester_id = user_id;
      this.user_cellphone = cellphone;
    }//end if
    this.status = status;

    this.crater_a = crater_a;
    this.list_crater_a_temp = [];
    for (var i = 0; i < this.list_crater_a.length; i++) {
      if (this.list_crater_a[i].shop_crater_floor == this.default_floor) {
        this.list_crater_a_temp.push(this.list_crater_a[i]);
      }
    }//end for
    if (crater_a != undefined) { this.change_crater_a_temp(crater_a); } // این شرط برای زمان جستجو می باشد

    this.f2_diff = f2_diff;
    this.f2 = Number(f2) + Number(f2_diff);

    if (type != 3) { this.type_ceil = type_ceil; }

    this.meter = meter;
    this.tip = tip;

    this.f3_diff = f3_diff;
    this.f3 = Number(f3) + Number(f3_diff);

    this.design = design;
    this.design_temp = design;
    this.design_all = design_all;

    this.position = position;
    this.f4_diff = f4_diff;
    this.f4 = Number(f4) + Number(f4_diff);

    this.site = site;
    this.f5_diff = f5_diff;
    this.f5 = Number(f5) + Number(f5_diff);

    this.open_crater = open_crater;
    this.f6_diff = f6_diff;
    this.f6 = Number(f6) + Number(f6_diff);

    this.height = height;
    this.f7_diff = f7_diff;
    this.f7 = Number(f7) + Number(f7_diff);

    this.place = place;
    this.save_place = place;
    this.f8_diff = f8_diff;
    this.f8 = Number(f8) * Number(place_f8) + Number(f8_diff);



    this.height = height;
    this.weight_diff = weight_diff;
    this.weight1_diff = weight1_diff;
    this.design_diff = design_diff;
    this.price_lsf1_number_diff = price_lsf1_number_diff;
    this.price_lsf2_number_diff = price_lsf2_number_diff;
    this.price_lsf3_number_diff = price_lsf3_number_diff;
    this.install_diff = install_diff;
    this.install1_diff = install1_diff;
    this.install2_diff = install2_diff;
    this.discount = discount;
    this.discount_install2 = discount_install2;
    this.discount_all = discount_all;
    this.discount_mwf = discount_mwf;
    this.discount_price_lsf1 = discount_price_lsf1;
    this.discount_price_lsf2 = discount_price_lsf2;
    this.discount_price_lsf3 = discount_price_lsf3;
    this.discount_design_all = discount_design_all;
    this.hard = hard;
    this.arch1 = arch1;
    this.arch2 = arch2;
    this.wast = wast;
    this.wast_weight = wast_weight;
    this.wast_price = wast_price;
    this.address = address;
    this.comment = comment;
    this.price = price;
    this.discount_festival = discount_festival;
    this.discount_festival_price = discount_festival_price;
    this.height_floor = height_floor;
    this.select_weight_weight = weight;
    this.weight = (Number(weight) + ((Number(this.height_floor - 3) * 5)) + Number(this.weight1_diff)).toFixed(3);
    this.mv = mv;
    this.bana_all_diff = bana_all_diff;
    this.bana_all = bana_all;
    this.task_type = type;
    this.mwf2 = mwf2;
    this.mwf = mwf;
    this.price_lsf = price_lsf;
    this.install = install;
    this.install1 = install1;
    this.install2 = install2;
    this.price_all_without_discount = price_all_without_discount;
    this.price_all_factor2_without_discount = price_all_factor2_without_discount;
    this.price_all1 = price_all1;
    this.price_all2 = price_all2;
    this.price_all = price_all;
    this.percent = percent;
    this.tax_check_value = tax_check_value;
    this.price_final = price_final;
    this.price_factor2_with_discount = price_factor2_with_discount;
    this.price_factor2 = price_factor2;
    this.price_factor2_final = price_factor2_final;
    this.price_factor2_tax = price_factor2_tax;
    this.price_factor2_discount = price_factor2_discount;
    this.price_factor3_with_discount = price_factor3_with_discount;
    this.price_factor3 = price_factor3;
    this.price_factor3_final = price_factor3_final; this.price_factor3_tax = price_factor3_tax;
    this.price_factor3_discount = price_factor3_discount;
    //this.f6_diff=f6_diff;
    //this.f6=Number(f6)+Number(f6_diff);
    //this.f7_diff=f7_diff;
    //this.f7=Number(f7)+Number(f7_diff);
    //this.f8_diff=f8_diff;
    //this.f8=Number(f8)+Number(f8_diff);
    this.price_lsf1_number = price_lsf1_number;
    this.price_lsf2_number = price_lsf2_number;
    this.price_lsf3_number = price_lsf3_number;
    this.price_lsf1_price = price_lsf1_price;
    this.price_lsf2_price = price_lsf2_price;
    this.price_lsf3_price = price_lsf3_price;
    this.price_lsf1 = price_lsf1;
    this.price_lsf2 = price_lsf2;
    this.price_lsf3 = price_lsf3;
    this.bullet = bullet;
    this.code_factor = code_factor;
    this.date = date;
    this.contract = contract;
    if (typeof this.contract !== 'object' && this.contract !== null && type != 3) {
      this.contract = this.contract.replace(/<[^>]*>/g, "");
      this.contract = this.contract.replace(/&nbsp/g, "");
      this.contract = this.contract.replace(/;/g, "");
    }//end if
    this.recieve_floor();
    //this.get_forms();

    if (type == 1) {
      this.type = 1;
      //this.myModal.open();
    }//end if
    if (type == 2) {
      this.type = 2;
      //this.myModal.open();
    }//end else
    if (type == 3) {
      this.type = 3;
      //this.myModalSearch.open();
    }

  }//end change_task

  close() {
    this.matDialogRef.close(this.result);
  }

  /*
  get_forms() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 79 }).subscribe(
      (res) => {
        this.list_forms = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_forms.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }
  */



  change_items(f: NgForm, type_type_ceil) {
    this.discount = Number(this.discount_design_all) + Number(this.discount_price_lsf1) + Number(this.discount_price_lsf2) + Number(this.discount_price_lsf3) + Number(this.discount_mwf) + Number(this.discount_install2) + Number(this.discount_all);
    this.wast = Number(this.wast_weight) * Number(this.wast_price);
    this.f1 = (<HTMLInputElement>document.getElementById("floor")).value.split(",")[1];
    this.f1 = Number(this.f1) + Number(this.f1_diff);
    this.price = f.value.price;
    // این قسمت برای طراحی سازه با کد 3 می باشد . صورتحساب فروش کالا از قیمت تقریبی کالا کسر می گردد
    if (this.product == 3) {
      this.price = 0;
    }//end if
    //****************** */
    this.bana_all = f.value.bana_all;

    this.default_height = <HTMLInputElement>document.getElementById("height");
    this.height = Number(this.default_height.value.split(",")[0]);
    this.f7 = Number(this.default_height.value.split(",")[1]) + Number(this.f7_diff);
    this.height_floor = Number(this.default_height.value.split(",")[2]);//ضریب ارتفاع طبقات برای به دست آوردن وزن سازه
    this.default_select_weight = <HTMLInputElement>document.getElementById("select_weight");
    this.select_weight_weight = Number(this.default_select_weight.value.split(",")[1]);
    this.weight = (Number(this.select_weight_weight) + ((Number(this.height_floor) - 3) * 5) + Number(this.weight1_diff)).toFixed(3);

    if (type_type_ceil == 1) { this.type_ceil = Number(this.default_select_weight.value.split(",")[0]); }
    this.f2 = Number(this.default_select_weight.value.split(",")[2]) + Number(this.f2_diff);
    this.mv = Number(this.weight) * Number(this.bana_all) + Number(this.weight_diff);

    if (this.tip == 1) {
      this.design = Number(0);
      this.design_diff = 0;
    }
    else if (this.tip == 2) { this.design = Number(this.design_temp); }
    this.design_all = Number(this.design) * Number(this.bana_all) + Number(this.design_diff);

    this.mwf = Number(this.mv) * Number(this.price);// محاسبه سازه درب کارخانه بدون تخفیف جشنواره
    this.discount_festival_price = this.mwf * this.discount_festival / 100;// تخفیف جشنواره
    this.mwf2 = Math.round(Number(this.mwf) / Number(this.bana_all));


    this.default_open_crater = <HTMLInputElement>document.getElementById("open_crater");
    this.open_crater = Number(this.default_open_crater.value.split(",")[0]);
    this.f6 = Number(this.default_open_crater.value.split(",")[1]) + Number(this.f6_diff);

    if (this.product == 1 || this.product == 4 || this.product == 3) {
      this.default_position = <HTMLInputElement>document.getElementById("position");
      this.position = Number(this.default_position.value.split(",")[0]);
    }
    if (this.product == 1 || this.product == 4) {
      this.f4 = Number(this.default_position.value.split(",")[1]) + Number(this.f4_diff);

      this.default_site = <HTMLInputElement>document.getElementById("site");
      this.site = Number(this.default_site.value.split(",")[0]);
      this.f5 = Number(this.default_site.value.split(",")[1]) + Number(this.f5_diff);

      this.default_place = <HTMLInputElement>document.getElementById("place");
      this.place = Number(this.default_place.value.split(",")[0]);
      if (this.access_update == true || this.save_place != this.place) {
        this.f8 = Number(this.default_place.value.split(",")[1]) + Number(this.f8_diff);
        this.save_place = this.place;
      }
      else this.f8 = this.f8

      this.install = parseFloat(this.f1) * parseFloat(this.f2) * parseFloat(this.f3) * parseFloat(this.f4) * parseFloat(this.f5) * parseFloat(this.f6) * parseFloat(this.f7) * parseFloat(this.f8) + parseFloat(this.install_diff);

      this.install1 = Math.round(Number(this.weight) * Number(this.install) + Number(this.install1_diff));
      this.install2 = Math.round(Number(this.install) * Number(this.mv) + Number(this.install2_diff));
    }//end this.product == 1

    if (this.product == 2) {
      this.position = 0;
      this.f4 = 0;
      this.site = 0;
      this.f5 = 0;
      //this.open_crater= 0;
      this.f6 = 0;
      //this.height=0;
      this.f7 = 0;
      this.place = 0;
      this.f8 = 0;
      this.install = 0;
      this.install1 = 0;
      this.install2 = 0;
    }//end 


    if (this.bullet == 1) {
      this.price_lsf1_number = Math.round((Number(this.mv) * 2) + Number(this.price_lsf1_number_diff));
      this.price_lsf2_number = Math.round((Number(this.mv) * 2) / 3 + Number(this.price_lsf2_number_diff));
      this.price_lsf3_number = Math.round((Number(this.bana_all) / Number(this.number1) * 65) / 100 + Number(this.price_lsf3_number_diff));
      this.price_lsf1_price = Math.round(Number(this.price_lsf1_number) * Number(this.price_lsf1));
      this.price_lsf2_price = Math.round(Number(this.price_lsf2_number) * Number(this.price_lsf2));
      this.price_lsf3_price = Math.round(Number(this.price_lsf3_number) * Number(this.price_lsf3));
      this.price_lsf = Number(this.price_lsf1_price) + Number(this.price_lsf2_price) + Number(this.price_lsf3_price);
    }//end if
    else {
      this.price_lsf1_number = 0;
      this.price_lsf2_number = 0;
      this.price_lsf3_number = 0;
      this.price_lsf1_price = 0;
      this.price_lsf2_price = 0;
      this.price_lsf3_price = 0;
      this.price_lsf = 0;
    }
    if (this.product == 3) {
      this.price_lsf = 0;
      this.install2 = 0;
      this.hard = 0;
      this.mwf = 0;
      this.wast = 0;
    }//end this.product == 3
    this.price_all_without_discount = Number(this.mwf) + Number(this.price_lsf) + Number(this.install2) + Number(this.design_all) + Number(this.arch1) + Number(this.arch2) + Number(this.hard);
    this.price_all_factor2_without_discount = Number(this.price_lsf) + Number(this.mwf);
    this.price_all_factor3_without_discount = Number(this.install2) + Number(this.design_all) + Number(this.arch1) + Number(this.arch2) + Number(this.hard);


    this.price_all = Number(this.mwf) + Number(this.price_lsf) + Number(this.install2) + Number(this.design_all) + Number(this.arch1) + Number(this.arch2) + Number(this.wast) - Number(this.discount) - Number(this.discount_festival_price);
    this.price_all2 = Number(this.mwf) + Number(this.price_lsf);
    this.price_all1 = Math.round(Number(this.price_all / Number(this.bana_all)));

    if (this.tax_check_value == 2) { this.percent = Math.round(this.price_all * 9 / 100); }
    if (this.tax_check_value == 1) { this.percent = 0; }
    this.price_final = Number(this.percent) + Number(this.price_all);


    this.price_factor2_discount = Number(this.discount_price_lsf1) + Number(this.discount_price_lsf2) + Number(this.discount_price_lsf3) + Number(this.discount_mwf);
    this.price_factor2 = Math.round(Number(this.price_lsf) + Number(this.mwf));
    this.price_factor2_with_discount = Number(this.price_factor2) - Number(this.price_factor2_discount);
    if (this.tax_check_value == 2) { this.price_factor2_tax = Math.round(this.price_factor2_with_discount * 9 / 100); }
    if (this.tax_check_value == 1) { this.price_factor2_tax = 0; }
    this.price_factor2_final = Math.round(Number(this.price_factor2_with_discount) + Number(this.price_factor2_tax));
    //************ */


    this.price_factor3_discount = Number(this.discount_design_all) + Number(this.discount_install2);
    this.price_factor3 = Math.round(Number(this.install2) + Number(this.design_all) + Number(this.arch1) + Number(this.arch2));
    this.price_factor3_with_discount = Number(this.price_factor3) - Number(this.price_factor3_discount);
    if (this.tax_check_value == 2) { this.price_factor3_tax = Math.round(this.price_factor3_with_discount * 9 / 100); }
    if (this.tax_check_value == 1) { this.price_factor3_tax = 0; }
    this.price_factor3_final = Math.round(Number(this.price_factor3_with_discount) + Number(this.price_factor3_tax));

  }//change_items


  open_fs() {
    this.fs.open();
  }

  open_price_lsf() {
    this.price_lsf_modal.open();
  }

  openModal() {
    //this.myModal.open();   
  }

  open_mv_modal() {
    this.mv_modal.open();
  }



  open_weight_modal() {
    this.weight_modal.open();
  }

  open_factor(type) {
    this.factor_type = type;
    this.factor.open();
  }



  open_design_modal() {
    this.design_modal.open();
  }

  open_install1() {
    this.install1_modal.open();
  }

  open_install2() {
    this.install2_modal.open();
  }

  open_price_all_without_discount() {
    this.price_all_without_discount_modal.open();
  }

  open_price_all1() {
    this.price_all1_modal.open();
  }

  open_price_all() {
    this.price_all_modal.open();
  }

  open_price_all_m() {
    this.price_all_m_modal.open();
  }

  open_profile_user(fname, cellphone, username) {
    this.user_fname = fname;
    this.user_cellphone = cellphone;
    this.user_username = username;
    this.profile_user_modal.open();
  }



  get_bg(id) {
    this.id = id;
    localStorage.setItem('PurRequesterOpenComponentLocalId' + this.code, JSON.stringify(id));
  }

  //****************************************************************************** 
  recieve_floor() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 263, tip: this.tip }).subscribe(
      (res) => {
        this.list_floor = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_floor.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }//end recieve_data

  recieve_crater_a() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10610, type: 1 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_crater_a.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.err = " خطا در دریافت ";
          this.err_validation = true;
        }
      }
    )
  }//end recieve_data

  recieve_tip() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10611 }).subscribe(
      (res: any) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_tip.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.err = " خطا در دریافت ";
          this.err_validation = true;
        }
      }
    )
  }//end recieve_tip

  recieve_position() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10612 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_position.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.err = " خطا در دریافت ";
          this.err_validation = true;
        }
      }
    )
  }//end recieve_position

  recieve_site() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10616 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_site.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.err = " خطا در دریافت ";
          this.err_validation = true;
        }
      }
    )
  }//end recieve_data

  recieve_open_crater() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10614, type: 2, floor: this.floor }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_open_crater.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.err = " خطا در دریافت ";
          this.err_validation = true;
        }
      }
    )
  }//end recieve_data

  recieve_height() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10615, type: 2, floor: this.floor }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_height.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.err = " خطا در دریافت ";
          this.err_validation = true;
        }
      }
    )
  }//end recieve_data

  recieve_place() {
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10613 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_place.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.err = " خطا در دریافت ";
          this.err_validation = true;
        }
      }
    )
  }//end recieve_data

  recieve_status() {
    if (this.check_internet() == false) { return; }
    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10473 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_status.push(res['result'][i]);
          }//end for
        }//end if
        else {
          this.err = " خطا در دریافت ";
          this.err_validation = true;
        }
      }
    )
  }//end recieve_data

  change_tip() {
    if (this.serverService.check_internet()['status'] == false) {
      var pe_message = "خطا در اینترنت";
      var pe_action = "بستن";
      this.recieve_message(true, 'Erorr in Internet', pe_message, 1, 'close', pe_action);
      return;
    }//end if
    else { this.matSnackBar.dismiss(); }
    this.loading = true;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 263, tip: this.tip }).subscribe(
      (res) => {
        this.list_floor = [];
        if (res['status'] == 1) {
          for (var i = 0; i < res['num']; i++) {
            this.list_floor.push(res['result'][i]);
          }//end for
          this.recieve_message(false, "", "", 1, "", "");
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 1, 'close', pe_action);
        }
      }
    )
  }

  change_floor(floor) {
    this.weight = 0;
    this.mv = 0;
    this.weight_diff = 0;
    this.weight1_diff;
    this.mwf = 0;
    this.mwf2 = 0;
    this.f2 = 1;
    this.f6 = 1;
    this.f7 = 1;
    this.type_ceil = 0;
    this.open_crater = 0;
    this.height = 0;
    this.select_weight_status = true;
    this.type_ceil = 0;
    this.f1_diff = 0;
    this.f2_diff = 0;
    this.f6_diff = 0;
    this.f7_diff = 0;

    this.default_floor = <HTMLInputElement>document.getElementById("floor");
    this.floor = this.default_floor.value.split(",")[0];
    this.f1 = Number(this.default_floor.value.split(",")[1]) + Number(this.f1_diff);
    this.number1 = this.default_floor.value.split(",")[2];
    this.design_diff = 0;
    this.install = parseFloat(this.f1) * parseFloat(this.f2) * parseFloat(this.f3) * parseFloat(this.f4) * parseFloat(this.f5) * parseFloat(this.f6) * parseFloat(this.f7) * parseFloat(this.f8) + parseFloat(this.install_diff);
    this.install1 = 0; this.install1_diff = 0;
    this.install2 = 0; this.install2_diff = 0;
    this.price_lsf1_number = 0;
    this.price_lsf2_number = 0;
    this.price_lsf3_number = 0;
    this.price_lsf1_price = 0;
    this.price_lsf2_price = 0;
    this.price_lsf3_price = 0;
    this.price_lsf = 0;
    this.price_lsf1_number_diff = 0;
    this.price_lsf2_number_diff = 0;
    this.price_lsf3_number_diff = 0;

    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10617, floor: this.floor, type: 2 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.list_crater_a_temp = [];
          this.crater_a = 0;
          for (var i = 0; i < res['num']; i++) {
            this.list_crater_a_temp.push(res['result'][i]);
          }//end for

          this.loading = false;
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 2, 'close', pe_action);
        }
      }
    )

    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10619, floor: this.floor }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          if (res['num'] != 0) {
            this.design_temp = res['result'][0]['shop_design_price'];
            if (this.tip == 1) this.design = Number(0);
            if (this.tip == 2) this.design = Number(res['result'][0]['shop_design_price']);
          }//end if
          else {
            this.design = 0;
            this.design_temp = 0;
          }
          this.design_all = Number(this.design) * Number(this.bana_all);
          this.loading = false;
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 2, 'close', pe_action);
        }
      }
    )

    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10620, floor: this.floor, type: 2 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.list_height = [];
          for (var i = 0; i < res['num']; i++) {
            this.list_height.push(res['result'][i]);
          }//end for
          this.loading = false;
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 2, 'close', pe_action);
        }
      }
    )

    this.subscription = this.serverService.post_address(this.server, 'new_address', { address: 10614, floor: this.floor, type: 2 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.list_open_crater = [];
          for (var i = 0; i < res['num']; i++) {
            this.list_open_crater.push(res['result'][i]);
          }//end for
          this.loading = false;
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 2, 'close', pe_action);
        }
      }
    )

    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 272, floor: this.floor }).subscribe(
      (res) => {
        if (res['status'] == 1 && res['num'] == 1) {
          this.plan = res['result'][0].shop_shop_floor_plan;
          this.bana_all = res['result'][0].shop_shop_floor_meter;
          this.loading = false;
        }//end if
        else {
          var pe_message = "خطا در دریافت";
          var pe_action = "بستن";
          this.recieve_message(true, 'Erorr in recieve', pe_message, 2, 'close', pe_action);
        }
      }
    )

  }//end change_floor



  change_crater_a(crater) {
    var value = crater.target.value;
    this.crater_a = crater.target.value;
    if (this.crater_a != 0) {
      this.loading = true;
      this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 10610, crater: value, type: 3 }).subscribe(
        (res) => {
          if (res['status'] == 1) {
            this.weight1 = res['weight1'];
            this.weight2 = res['weight2'];
            this.price1 = res['price1'];
            this.price2 = res['price2'];
            this.weight = 0;
            this.mv = 0;
            this.weight_diff = 0;
            this.weight1_diff = 0;
            this.mwf = 0;
            this.mwf2 = 0;
            this.price_lsf1_number_diff = 0;
            this.price_lsf2_number_diff = 0;
            this.price_lsf3_number_diff = 0;
            this.price_lsf1_number = 0;
            this.price_lsf2_number = 0;
            this.price_lsf3_number = 0;
            this.price_lsf1_price = 0;
            this.price_lsf2_price = 0;
            this.price_lsf3_price = 0;
            this.price_lsf = 0;
            this.type_ceil = 0;
            this.install1 = 0;
            this.install1_diff = 0;
            this.install2_diff = 0;
            this.f2_diff = 0;
            this.install2 = 0;
            this.select_weight_status = false;
            this.price_all_without_discount = Number(this.mwf) + Number(this.price_lsf) + Number(this.install2) + Number(this.design_all) + Number(this.arch1) + Number(this.arch2) + Number(this.hard);
            this.price_all_factor2_without_discount = Number(this.price_lsf) + Number(this.mwf);


            this.price_all = Number(this.mwf) + Number(this.price_lsf) + Number(this.install2) + Number(this.design_all) + Number(this.arch1) + Number(this.arch2) + Number(this.wast) - Number(this.discount);
            this.price_all = Number(this.mwf) + Number(this.price_lsf);

            this.price_all1 = Math.round(Number(this.price_all / Number(this.bana_all)));
            if (this.tax_check_value == 2) { this.percent = Math.round(this.price_all * 9 / 100); }
            if (this.tax_check_value == 1) { this.percent = 0; }
            this.price_final = Number(this.percent) + Number(this.price_all);
            this.loading = false;
          }//end if
          else {
            this.loading = false;
            this.err = " خطا در دریافت ";
            this.err_validation = true;
          }
        }
      )
    }//end if
    else {
      this.weight = 0;
      this.mv = 0;
      this.weight_diff = 0;
      this.weight1_diff = 0;
      this.mwf = 0;
      this.mwf2 = 0;
      this.f2 = 1;
      this.type_ceil = 0;
      this.select_weight_status = true;
      this.type_ceil = 0;
    }//end else
  }//end change_crater


  change_crater_a_temp(crater) {
    var value = crater;
    this.subscription = this.serverService.post_address(this.server, 'new_address', { 'address': 10610, crater: value, type: 3 }).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.weight1 = res['weight1'];
          this.weight2 = res['weight2'];
          this.price1 = res['price1'];
          this.price2 = res['price2'];
          this.loading = false;
        }//end if
        else {
          this.loading = false;
          this.err = " خطا در دریافت ";
          this.err_validation = true;
        }
      }
    )
  }//end if

  add_user() {
    const dialogRef = this.dialog.open(UserInsertComponent, {
      width: '45rem',
      height: 'auto',
    });

    dialogRef.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.requester_title = res.user_title;
          this.requester_id = res.user_id
          this.user_sms = res.user_id
        }
      }
    )
  }
  //************************************************************************** */
  open_modal_mwf2() {
    this.modal_mwf2.open();
  }

  open_modal_mwf() {
    this.modal_mwf.open();
  }
  //******************************************************************************
  select_requester_title(type) {
    this.type_user = type;
    this.list_requester = [];
    this.requester_title_search_modal = [];
    this.requester_title2_search_modal = [];
    this.myModalSelect.open();
  }//end select_requester_title

  search_new_requester() {
    if (this.check_internet() == false) { return; }
    this.loading = true;
    this.requester_title_search_modal = this.requester_title_search_modal;
    this.username_search_modal = this.username_search_modal;

    this.obj_search_requester = { 'username_search': this.username_search_modal, 'requester_title_search': this.requester_title_search_modal, 'requester_title2_search': this.requester_title2_search_modal, 'type': this.type, 'lang': this.lang }
    this.searchSupplierService.search_new_supplier(this.obj_search_requester, this.server).subscribe(
      (res) => {
        if (res['status'] == 1) {
          this.list_requester = res['result'];
          this.loading = false;
        } //end if
        else {
          this.err = " خطا در دریافت ";
          this.err_validation = true;
          this.loading = false;
        }
      }//end res:Response 
    )//end subscribe
  }//end search_material

  select_requester(id, title, title2, username, cellphone) {
    if (this.lang == 1) { this.requester_title = title; }
    if (this.lang == 2) { this.requester_title = title2; }
    this.requester_id = id;
    this.user_sms = id;
    this.user_cellphone = cellphone;
    this.requester_contract_id = username;
    this.myModalSelect.close();
  }//end select_goods

  select_requester_search(id, title, title2, username) {
    this.requester_title_search = title;
    this.user_sms = id;
    this.requester_id_search = username;
    this.myModalSelect.close();
  }//end select_goods

  search_requester_reset(type) {
    if (type == 1) {
      this.requester_title = "";
      this.requester_id = "";
    }//end if

    if (type == 3) {
      this.requester_title_search = "";
      this.requester_id_search = "";
    }//end if


    this.myModalSelect.close();
  }



  //*******************************************************************************
  open_contract() {
    this.modal_contract.open();
  }//end open_contract

  open_modal_factor2() {
    this.modal_factor2.open();
  }//end open_modal_factor2 

  open_modal_factor3() {
    this.modal_factor3.open();
  }//end open_modal_factor3

  open_modal_discount() {
    this.modal_discount.open();
  }//end open_modal_discount

  open_modal_wast() {
    this.modal_wast.open();
  }//end open_modal_discount


  open_document(event: any) {
    this.document = event.target.value;
    if (this.document == 7) {
      this.dialog.open(SaleDocumentDeclarationComponent, {
        width: '1000px',
        height: 'auto',
        hasBackdrop: false
      })
    }//end if
  }
  //*******************************************************************************
  ConvertToInt(val) {
    return parseInt(val);
  }

  ConvertToRound(val) {
    return Math.ceil(val);
  }

  check_internet() {
    this.isOnline = navigator.onLine;
    if (this.isOnline == false) {
      this.err_internet_text = "Error in internet connecting";
      this.err_internet_validation = true;
      return false;
    }
    else {
      this.err_internet_validation = false;
    }//end else
  }//end check_internet


  recieve_erorr(err_validation, loading, en_message, pe_message, type) {
    this.err_validation = err_validation;
    if (type == 1) this.loading = loading;
    if (this.lang == 1) { this.err = pe_message; }
    if (this.lang == 2) { this.err = en_message; }
  }//end 


  recieve_message(validation, en_message, pe_message, type, en_action, pe_action) {
    this.err_internet_validation = false;
    if (type == 1) this.loading = false;
    if (validation == true) {
      this.matSnackBar.open(pe_message, pe_action, { duration: 2000 });
    }//end if
    else {
      //this.matSnackBar.dismiss();
    }
  }

  ModalClose() {
    this.recieve_erorr(false, false, "", "", 1);
  }

  attachment() {
    this.dialog.open(SaleAttachmentComponent, {
      width: '1000px',
      height: '100%',
      data: { id: this.id, 'factor': this.code_factor }
    });
  }
  //*******************************************************************************


}
